import { Component, OnInit, ViewChild, Input, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { PatentDraftDataForm } from '../_models/patent-draft-data-form';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { PatentDraftService } from '../_services/patent-draft.service';
import { MatStepper, MatExpansionPanel } from '@angular/material';
import { WhiteSpaceValidators } from '../shared/whitespace.validator';
import { SessionActivityDataForm } from '../_models/session-activity-data-form';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { MaxWordCountValidator } from '../shared/maxWordCountValidator.directive';
import { BasicOfInventionDetailsService } from '../_services/basic-of-invention-details.service';
import { BasicInventionDetailsDataForm } from '../_models/basic-invention-details-data-form';

@Component({
  selector: 'app-patent-draft-save-update',
  templateUrl: './patent-draft-save-update.component.html',
  styleUrls: ['./patent-draft-save-update.component.css']
})

export class PatentDraftSaveUpdateComponent implements OnInit {
  patentDraftDataForm: PatentDraftDataForm = new PatentDraftDataForm();
  patentDraftDataFormGroup: FormGroup;
  saveFlag = '';
  updateFlag = '';
  patentDraftBriefDescriptionId: any;
  projectId: any;
  patentDraftDetailedDescriptionId: any;
  previousStep: string = 'Previous step';
  nextStep: string = 'Next step';
  userDataSession;
  userDetailsId = 0;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm()
  lastSessionActivityNumber: number;
  projectTitle: String = 'Project Title';
  wordCount: number;
  isOptional: true;
  basicInventionDetailsDataForm: BasicInventionDetailsDataForm = new BasicInventionDetailsDataForm();
  sessionActivity;
  userSession;
  doingStatusSelected: string = 'Patent Drafting';

  @ViewChild('stepper') stepper: MatStepper;
  @Input('matTooltip') message: string;
  @ViewChildren('tooltip') tooltips;
  _allExpandState = false;
  @ViewChildren(MatExpansionPanel) viewPanels: QueryList<MatExpansionPanel>;
  @ViewChild('firstInput') firstInput: ElementRef
  @ViewChild('secondInput') secondInput: ElementRef
  @ViewChild('thirdInput') thirdInput: ElementRef
  @ViewChild('fourthInput') fourthInput: ElementRef
  @ViewChild('fifthInput') fifthInput: ElementRef
  @ViewChild('sixthInput') sixthInput: ElementRef
  @ViewChild('seventhInput') seventhInput: ElementRef
  @ViewChild('eighthInput') eighthInput: ElementRef
  @ViewChild('ninthInput') ninthInput: ElementRef
  @ViewChild('tenthInput') tenthInput: ElementRef
  @ViewChild('eleventhInput') eleventhInput: ElementRef
  @ViewChild('twelfthInput') twelfthInput: ElementRef
  @ViewChild('thirteenInput') thirteenInput: ElementRef
  @ViewChild('fourteenInput') fourteenInput: ElementRef
  @ViewChild('fifteenInput') fifteenInput: ElementRef
  @ViewChild('sixteenInput') sixteenInput: ElementRef
  @ViewChild('seventeenInput') seventeenInput: ElementRef

  constructor(
    private router: Router,
    private formbuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private patentDraftService: PatentDraftService,
    private sesssionActivityService: SesssionActivityService,
    private basicOfInventionDetailsService: BasicOfInventionDetailsService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
    this.masterTypeFormValidate();
    this.userSession = localStorage.getItem('currentUser');
    this.patentDraftDataForm.userSessionDataForm = JSON.parse(this.userSession);
    this.userDetailsId = this.patentDraftDataForm.userSessionDataForm.userDetailsId;
    this.patentDraftDataFormGroup.get('relevantPatentDocumentsGroup.relevantPatentDocumentStatus').valueChanges.subscribe(value => this.setRelevantPatents(value));
    this.patentDraftDataFormGroup.get('nplGroup.paperPublishedStatus').valueChanges.subscribe(value => this.setNpl(value));

    if (this.updateFlag == 'true' && this.projectId > 0) {
      this.activatedRoute.data.subscribe(
        data => {
          const resolvedData: PatentDraftDataForm = data['resolvedData'];
          this.patentDraftDetailsRetrievedByProjectId(resolvedData);
          //console.log(resolvedData);
        }
      )
      this.getBasicInventionByProjectId(this.projectId);
    }
  }

  getBasicInventionByProjectId(projectId) {
    this.basicOfInventionDetailsService.getBasicInventionDetailsByprojectId(projectId).subscribe(
      resp => {
        this.basicInventionDetailsDataForm = resp as BasicInventionDetailsDataForm;
        if (this.basicInventionDetailsDataForm.inventionType === 'Complete') {
          this.patentDraftDataFormGroup.get('drawingDescription').setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
          this.patentDraftDataFormGroup.get('claims').setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
        }
        else {
          this.patentDraftDataFormGroup.get('drawingDescription').clearValidators();
          this.patentDraftDataFormGroup.get('claims').clearValidators();
        }
        this.patentDraftDataFormGroup.get('drawingDescription').updateValueAndValidity();
        this.patentDraftDataFormGroup.get('claims').updateValueAndValidity();
      },
      error => {
        console.log(error)
      })
  }

  getWordCount() {
    this.wordCount = ((this.patentDraftDataForm.abstractDetails || '').match(/\S+/g) || []).length;
  }

  public set allExpandState(value: boolean) {
    this._allExpandState = value;
    this.togglePanels(value);
  }

  expandLess(value) {
    switch (value) {
      case 1:
        this.firstInput.nativeElement.focus();
        break;
      case 2:
        this.secondInput.nativeElement.focus();
        break;
      case 3:
        this.thirdInput.nativeElement.focus();
        break;
      case 4:
        this.fourthInput.nativeElement.focus();
        break;
      case 5:
        this.fifthInput.nativeElement.focus();
        break;
      case 6:
        this.sixthInput.nativeElement.focus();
        break;
      case 7:
        this.seventhInput.nativeElement.focus();
        break;
      case 8:
        this.eighthInput.nativeElement.focus();
        break;
      case 9:
        this.ninthInput.nativeElement.focus();
        break;
      case 10:
        this.tenthInput.nativeElement.focus();
        break;
      case 11:
        this.eleventhInput.nativeElement.focus();
        break;
      case 12:
        this.twelfthInput.nativeElement.focus();
        break;
      case 13:
        this.thirteenInput.nativeElement.focus();
        break;
      case 14:
        this.fourteenInput.nativeElement.focus();
        break;
      case 15:
        this.fifteenInput.nativeElement.focus();
        break;
      case 16:
        this.sixteenInput.nativeElement.focus();
        break;
      case 17:
        this.seventeenInput.nativeElement.focus();
      default:
        break;
    }
  }

  public get allExpandState(): boolean {
    return this._allExpandState;
  }

  public togglePanels(value: boolean) {
    this.viewPanels.forEach(p => value ? p.open() : p.close());
  }

  patentDraftDetailsRetrievedByProjectId(patentDraftDataForm: PatentDraftDataForm) {
    this.patentDraftDataForm = patentDraftDataForm;
    if (this.patentDraftDataForm.abstractDetails === null) { }
    else {
      this.getWordCount();
    }
    this.projectTitle = this.patentDraftDataForm.projectDataForm.projectName;

    this.sesssionActivityService.getProjectLastSessionActiityByUserId(this.userDetailsId, 9, this.projectId).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                this.stepper.selectedIndex = step.index;
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  masterTypeFormValidate() {
    this.patentDraftDataFormGroup = this.formbuilder.group({
      inventionFields: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      technologyDevelopment: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      addressedProblem: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      relevantPatentDocumentsGroup: this.formbuilder.group({
        relevantPatentDocumentStatus: ['', [Validators.required]],
        relevantPatents: [''],
      }),
      nplGroup: this.formbuilder.group({
        paperPublishedStatus: ['', [Validators.required]],
        relevantNpl: [''],
      }),
      priorArtDrawbacks: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      solution: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionObjective: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      componentFunction: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      additionalFeatures: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionOverview: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      componentDetails: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      workFlow: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      drawingDescription: [''],
      advantages: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      claims: [''],
      abstractDetails: ['', [Validators.required, MaxWordCountValidator.validateWordCount, WhiteSpaceValidators.emptySpace()]],
    });
  }

  setRelevantPatents(relevantPatentStatus: string): void {
    const releventPatentControl = this.patentDraftDataFormGroup.get('relevantPatentDocumentsGroup.relevantPatents');
    if (relevantPatentStatus === 'Yes') {
      releventPatentControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
    }
    else {
      releventPatentControl.clearValidators();
    }
    releventPatentControl.updateValueAndValidity();
  }

  setNpl(publishStatus: string): void {
    const nplPatentControl = this.patentDraftDataFormGroup.get('nplGroup.relevantNpl');
    if (publishStatus === 'Yes') {
      nplPatentControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
    }
    else {
      nplPatentControl.clearValidators();
    }
    nplPatentControl.updateValueAndValidity();
  }

  getErrorMsgForInventionFields() {
    return this.patentDraftDataFormGroup.controls.inventionFields.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForBackground1() {
    return this.patentDraftDataFormGroup.controls.technologyDevelopment.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForBackground2() {
    return this.patentDraftDataFormGroup.controls.addressedProblem.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForBackground3() {
    return this.patentDraftDataFormGroup.controls.relevantPatents.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForBackground4() {
    return this.patentDraftDataFormGroup.controls.relevantNpl.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForBackground5() {
    return this.patentDraftDataFormGroup.controls.priorArtDrawbacks.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForBackground6() {
    return this.patentDraftDataFormGroup.controls.solution.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForSummary1() {
    return this.patentDraftDataFormGroup.controls.inventionObjective.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForSummary2() {
    return this.patentDraftDataFormGroup.controls.componentFunction.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForSummary3() {
    return this.patentDraftDataFormGroup.controls.additionalFeatures.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForDetailedDescription1() {
    return this.patentDraftDataFormGroup.controls.inventionOverview.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForDetailedDescription2() {
    return this.patentDraftDataFormGroup.controls.componentDetails.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForDetailedDescription3() {
    return this.patentDraftDataFormGroup.controls.workFlow.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForDetailedDescription4() {
    return this.patentDraftDataFormGroup.controls.drawingDescription.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForDetailedDescription5() {
    return this.patentDraftDataFormGroup.controls.advantages.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForClaims() {
    return this.patentDraftDataFormGroup.controls.claims.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }
  getErrorMsgForAbstract1() {
    return this.patentDraftDataFormGroup.controls.abstractDetails.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }


  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = "Area/Field of the invention";
        break;
      case 2:
        this.message = "The technology behind your invention and its development";
        break;
      case 3:
        this.message = "Problem in the existing systems / methods";
        break;
      case 4:
        this.message = "Relevant patent documents (if any)";
        break;
      case 5:
        this.message = "Any product (or) paper published relating to your invention";
        break;
      case 6:
        this.message = "Drawback behind the existing systems / methods";
        break;
      case 7:
        this.message = "Solution addressed by your invention to overcome the problem";
        break;
      case 8:
        this.message = "Objective of your invention";
        break;
      case 9:
        this.message = "Components / process of your invention with their functionality";
        break;
      case 10:
        this.message = "Additional features of your invention (if any)";
        break;
      case 11:
        this.message = "Overview of the invention";
        break;
      case 12:
        this.message = "Components / process involved in the invention with their functionality in detail";
        break;
      case 13:
        this.message = "Working of the invention";
        break;
      case 14:
        this.message = "Describe the invention based on each drawing (if any) separately";
        break;
      case 15:
        this.message = "Advantages of your invention";
        break;
      case 16:
        this.message = "I / We Claim (write about the new and important feature of your invention)";
        break;
      case 17:
        this.message = "Abstract";
      default:
        break;
    }
  }

  submitDetails() {
    this.sessionActivityDataForm.activityType = 9;
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.lastActivitySession = indexNumber;
    this.patentDraftDataForm.sessionActivityDataForm = this.sessionActivityDataForm;

    const currentUser = localStorage.getItem('currentUser');
    this.patentDraftDataForm.userSessionDataForm = JSON.parse(currentUser);

    this.patentDraftService.saveAndUpdateProject(this.patentDraftDataForm).subscribe(
      resp => {
        this.patentDraftDataForm = resp as PatentDraftDataForm;
        //console.log(this.patentDraftDataForm.relevantPatentDocumentStatus)
        this.projectTitle = this.patentDraftDataForm.projectDataForm.projectName;
      }, error => {
        console.log(error);
      })
  }

  moveToPreview() {
    if (this.patentDraftDataFormGroup.valid) {
      this.sessionActivityDataForm.activityType = 9;
      let indexNumber = this.stepper.selectedIndex + 1;
      this.sessionActivityDataForm.lastActivitySession = indexNumber;
      this.patentDraftDataForm.sessionActivityDataForm = this.sessionActivityDataForm;
      const currentUser = localStorage.getItem('currentUser');
      this.patentDraftDataForm.userSessionDataForm = JSON.parse(currentUser);
      this.patentDraftService.saveAndUpdateProject(this.patentDraftDataForm).subscribe(
        resp => {
          this.patentDraftDataForm = resp as PatentDraftDataForm;
          this.projectTitle = this.patentDraftDataForm.projectDataForm.projectName;
          this.router.navigate(['/main/preview', this.projectId]);
        }, error => {
          console.log(error);
        })
    }
  }
}